import {AfterViewInit, Component, OnInit, OnDestroy, AfterContentChecked} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {GenerateTokenService} from '../opd/generate-token/generate-token.service';

@Component({
  selector: 'app-token-display',
  templateUrl: './token-display.component.html',
  styleUrls: []
})
export class TokenDisplayComponent implements OnInit, OnDestroy {

    mstTokenList: Observable<any[]>;
    ind = 1;
    private alive: boolean;
  constructor(private generateTokenService: GenerateTokenService) { }

  ngOnInit() {
      this.generateTokenService.getTokenToDisplay().then(resp => {
        this.mstTokenList = resp;
          console.log(' this.mstTokenList ',  this.mstTokenList);
      });
      this.alive = true;

      Observable.timer(0,5000)
          .takeWhile(() => this.alive) // only fires when component is alive
          .subscribe(() => {
              this.generateTokenService.getTokenToDisplay().then(resp => {
                  this.mstTokenList = resp;
                  console.log(' this.mstTokenList ',  this.mstTokenList);
              });
          });
  }

   ngOnDestroy() {
        this.alive = false;
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-display/token-display.component.ts